import { formatNumber } from 'core/service/lib/number-format'

const RiderPremium = ({ isSelected, isSelectable, validationErrors, premium }) => {
  const premiumContent = () => {
    if (!isSelectable || validationErrors) {
      return <div className="value-pair">-</div>
    } else if (!isSelected) {
      return <div className="value-pair">0.00</div>
    } else {
      return <div className="value-pair">{formatNumber(premium, 2)}</div>
    }
  }

  return <div className="premium right">{premiumContent()}</div>
}

export default RiderPremium
